import Reflux from 'reflux';

const WidgetsActions = Reflux.createActions({
  'removeWidget': { asyncResult: true},
});

export default WidgetsActions;



// WEBPACK FOOTER //
// ../graylog2-server/graylog2-web-interface/src/actions/widgets/WidgetsActions.jsx